import { Component, OnInit, OnDestroy, Output } from '@angular/core';
import * as moment from 'moment/moment';
import { RealTimeContextService } from '../real-time-context.service';
import { Mode, Source, getLang } from '../../common/const';

@Component({
  selector: 'app-upcoming-events-header',
  templateUrl: './upcoming-events-header.component.html',
  styleUrls: ['./upcoming-events-header.component.scss']
})
export class UpcomingEventsHeaderComponent implements OnInit, OnDestroy {

  // @Output() upcoming: EventEmitter<boolean> = new EventEmitter<boolean>();
  data: any;
  currentData = 0;
  mode = Mode;
  interval = null;
  timeout = null;
  upcomingVisible = true;

  constructor(
    private realTimeContextService: RealTimeContextService
  ) { }

  ngOnInit() {
  }

  loadData(data) {
    this.data = data.filter(d => !d.properties.realtime);
    this._cancelInterval();
    this.interval = setInterval(() => {
      this.next(false);
    }, 4000);
  }

  next(cancelInterval = true) {
    if (cancelInterval) {
      this._cancelInterval();
    }
    if (this.currentData === this.data.length - 1) {
      this.currentData = 0;
    } else {
     this.currentData ++;
    }
  }

  prev() {
    this._cancelInterval();
    if (this.currentData === 0) {
      this.currentData = this.data.length - 1;
    } else {
      this.currentData --;
    }
  }

  formatDate(date) {
    moment.locale(getLang());
    return moment(date).format('DD/MM/YYYY - HH:mm');
  }

  toggleUpcoming() {
    this.upcomingVisible = !this.upcomingVisible;
  }

  private _cancelInterval() {
    if (this.interval) {
      window.clearInterval(this.interval);
    }
  }

  ngOnDestroy () {
    this._cancelInterval();
  }
}



// WEBPACK FOOTER //
// ./src/app/real-time/upcoming-events-header/upcoming-events-header.component.ts